import { useCallback } from 'react';

import { getFeatureConfig } from '@luna/feature-config';
import { downloadFile, downloadFileByForm } from '@shared/file';
import { getToken } from '@shared/auth';
import type { EnvironmentConfig } from '@luna/env';
import { getEnv } from '@luna/env';

type DownloadMethod = (url: string) => Promise<void>;
type DownloadErrorHandler = Parameters<typeof downloadFile>[0]['error'];

function downloadFileByLink(url: string, error?: DownloadErrorHandler): Promise<void> {
    const body = {
        access_token: getToken(),
        'WEB-API-key': getEnv<EnvironmentConfig>().webAPIClientId,
    };
    return downloadFile({ url, body, error });
}

export const useDownloadMethod = (error?: DownloadErrorHandler): DownloadMethod => {
    const { attachmentDownloadByForm } = getFeatureConfig(({ transactions }) => transactions);

    return useCallback(
        async (url: string) => {
            if (attachmentDownloadByForm) {
                return downloadFileByForm(url);
            }
            return downloadFileByLink(url, error);
        },
        [attachmentDownloadByForm],
    );
};
